module.exports = __webpack_public_path__ + "img/3hearts.c2fa3219.jpg";